'use strict';

// The following code was adapted from https://davidwalsh.name/javascript-loader

module.exports = (function() {
  function load(tag) {
    return function(url) {
      return new Promise((resolve, reject) => {
        const element = document.createElement(tag);
        let parent = 'body';
        let attr = 'src';

        element.onload = function() {
          resolve(url);
        };
        element.onerror = function() {
          reject(url);
        };

        switch (tag) {
          case 'script':
            element.async = true;
            element.defer = true;
            break;
          case 'link':
            element.type = 'text/css';
            element.rel = 'stylesheet';
            attr = 'href';
            parent = 'head';
        }

        element[attr] = url;
        document[parent].appendChild(element);
      });
    };
  }

  return {
    css: load('link'),
    js: load('script'),
  };
})();
